import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../utils/axios-base-query";
import { baseHttp } from "./http";
import * as tags from "constants/tags";
import {API_BASE_URL} from "../constants/env";

export const baseApi = createApi({
  reducerPath: "baseApi",
  baseQuery: axiosBaseQuery({ url: API_BASE_URL }, baseHttp),
  endpoints: (builder) => ({}),
}).enhanceEndpoints({ addTagTypes: Object.values(tags) });
